// Main javascript entry point
// Should handle bootstrapping/starting application

$ = jQuery.noConflict();

import Base from '../_modules/base/base';
import Masks from '../_modules/masks/masks';
import Slick from '../_modules/slick/slick';
import ExpandedMenu from '../_modules/expandedMenu/expandedMenu';
import formSubmitScroll from '../_modules/formSubmitScroll/formSubmitScroll';
import HomeHelpBlock from '../_components/homeHelpBlock/homeHelpBlock';
import gerenciarFavoritos from '../_modules/gerenciarFavoritos/gerenciarFavoritos';
import gerarBoleto from '../_components/gerarBoleto/gerarBoleto';
import calcPrice from '../_components/calcPrice/calcPrice';
import calcDistance from '../_components/calcDistance/calcDistance';
import popUp from '../_components/popUp/popUp';
import collapsedMenu from '../_components/collapsedMenu/collapsedMenu';
import input from '../_components/_input/input';
import topdf from '../_modules/topdf/topdf';

'use strict';
$(() => {


});
